import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GamifyIcon } from 'application/components/GamifyIcon';
import { typesMapper } from '../utils';
interface FieldCardProps {
  field: any; // You can type this more specifically based on your form field structure
  isSelected?: boolean;
}

const StyledFieldCard = styled(Box)<{ isSelected?: boolean }>(
  ({ theme, isSelected }) => ({
    backgroundColor: theme.custom?.isDark ? '#1E1E1E' : '#FFFFFF',
    border: `${isSelected ? '2px' : '1px'} solid ${
      isSelected ? theme.custom?.secondary : theme.custom?.stroke
    }`,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '8px',
    padding: '12px 16px',
    cursor: 'grab',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.custom?.background2 || '#F5F5F5',
      borderColor: theme.custom?.secondary || '#35829E',
    },
    '&:active': {
      cursor: 'grabbing',
    },
  })
);

export default function FieldCard({
  field,
  isSelected = false,
}: FieldCardProps) {
  return (
    <StyledFieldCard isSelected={isSelected}>
      <svg
        // onClick={(e) => {
        //   e.stopPropagation();
        //   console.log(disposition.iconName);
        //   console.log(pinItems[disposition.iconName as keyof typeof pinItems]);
        // }}
        width="13"
        height="6"
        viewBox="0 0 13 6"
        fill="none"
      >
        <path
          d="M0.875 2H12.125C12.2908 2 12.4497 1.89464 12.5669 1.70711C12.6842 1.51957 12.75 1.26522 12.75 1C12.75 0.734784 12.6842 0.48043 12.5669 0.292893C12.4497 0.105357 12.2908 0 12.125 0H0.875C0.70924 0 0.550268 0.105357 0.433058 0.292893C0.315848 0.48043 0.25 0.734784 0.25 1C0.25 1.26522 0.315848 1.51957 0.433058 1.70711C0.550268 1.89464 0.70924 2 0.875 2ZM12.125 4H0.875C0.70924 4 0.550268 4.10536 0.433058 4.29289C0.315848 4.48043 0.25 4.73478 0.25 5C0.25 5.26522 0.315848 5.51957 0.433058 5.70711C0.550268 5.89464 0.70924 6 0.875 6H12.125C12.2908 6 12.4497 5.89464 12.5669 5.70711C12.6842 5.51957 12.75 5.26522 12.75 5C12.75 4.73478 12.6842 4.48043 12.5669 4.29289C12.4497 4.10536 12.2908 4 12.125 4Z"
          fill="#A2ABB1"
        />
      </svg>
      <Box
        sx={(theme) => ({
          width: '48px',
          height: '48px',
          borderRadius: '500px',
          overflow: 'hidden',
          backgroundColor: theme.custom?.textLight || '#A2ABB1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 0,
        })}
      >
        <GamifyIcon icon={'notes'} color={'#FFFFFF'} />
      </Box>
      {field.name ? (
        <>
          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: 16,
                fontWeight: 600,
                color: theme.custom?.text,
              })}
            >
              {field.label}
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: 12,
                fontWeight: 400,
                color: theme.custom?.textLight,
              })}
            >
              {`Heading: ${field.heading}`}
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              justifySelf: 'flex-end',
              padding: 1,
              backgroundColor: theme.custom?.background3,
              borderRadius: 3,
              width: '80px',
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: `1px solid ${theme.custom?.stroke}`,
            })}
          >
            <Typography
              sx={(theme) => ({
                fontSize: 12,
                color: theme.custom?.textLight,
              })}
            >
              {typesMapper[field.type as keyof typeof typesMapper]}
            </Typography>
          </Box>
        </>
      ) : (
        <Typography
          sx={(theme) => ({
            fontSize: 16,
            fontWeight: 600,
            color: theme.custom?.text,
          })}
        >
          New Field
        </Typography>
      )}
    </StyledFieldCard>
  );
}
